!(function ($) {
    'use strict';

    // Cache frequently used selectors
    const $document = $(document);
    const $body = $('body');
    const $mainMenuArea = $('.main-menu-area');
    const $fullscreenBg = $('.mm-fullscreen-bg');
    const $filterSidebar = $('.filter-sidebar');
    const $leftSideWrap = $('.left-side-wrap');
    const $menuContent = $('.menu-content');

    // Constants
    const MOBILE_BREAKPOINT = 992;
    const ANIMATION_DELAY = 500;
    const MENU_ANIMATION_DELAY = 300;

    // Utility functions
    const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

    const toggleMenuVisibility = (show) => {
        $mainMenuArea.toggleClass('active', show);
        $fullscreenBg.toggleClass('active', show);
        $body.toggleClass('hidden', show);
    };

    const toggleFilterSidebar = (show) => {
        $filterSidebar.toggleClass('active', show);
        $fullscreenBg.toggleClass('active', show);
    };

    $(document).ready(function () {
        // Mobile menu toggle
        $('button.navbar-toggle').on('click', () => toggleMenuVisibility(true));

        // Close menu
        $('.close-box').on('click', () => toggleMenuVisibility(false));

        // Filter button toggle
        $('button.filter-button').on('click', function () {
            const $button = $(this);
            const $buttonText = $button.find('span');

            if (isMobile()) {
                toggleFilterSidebar(true);
            } else {
                const isActive = $leftSideWrap.hasClass('active');
                $leftSideWrap.toggleClass('active', !isActive);

                if (isActive) {
                    $filterSidebar.removeClass('active');
                    $buttonText.text('Show Filters');
                } else {
                    setTimeout(() => $filterSidebar.addClass('active'), ANIMATION_DELAY);
                    $buttonText.text('Hide filters');
                }
            }
        });

        // Fullscreen background click handler
        $fullscreenBg.on('click', function () {
            $mainMenuArea.removeClass('active');
            $filterSidebar.removeClass('active');
            $fullscreenBg.removeClass('active');
            $body.removeClass('hidden');
        });

        // Initialize Bootstrap tooltips
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
            new bootstrap.Tooltip(el);
        });

        // Product image zoom
        $('.full-view, .zoom').on('click', function () {
            $('.product_img_top')
                .magnificPopup({
                    delegate: 'a',
                    type: 'image',
                    showCloseBtn: true,
                    closeBtnInside: false,
                    midClick: true,
                    tLoading: 'Loading image #%curr%...',
                    mainClass: 'mfp-img-mobile',
                    gallery: {
                        enabled: true,
                        navigateByImgClick: true,
                        preload: [0, 1],
                    },
                })
                .magnificPopup('open');
        });

        // Menu navigation handlers
        const toggleMenuDropdown = ($item, open) => {
            const $dropdown = $item.find('.menu-dropdown').eq(0);

            if (open) {
                // Force a reflow to ensure iOS Safari applies the display change
                $item.addClass('open');
                $dropdown.addClass('open');
                $menuContent.addClass('open-level-1');
                // Trigger reflow
                void $dropdown[0].offsetHeight;
            } else {
                $item.removeClass('open');
                $dropdown.removeClass('open');
                $menuContent.removeClass('open-level-1');
            }
        };

        // Menu arrow click (mobile)
        $document.on('click', '.menu-arrow', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $item = $(this).closest('li');
            const isOpen = $item.hasClass('open');
            toggleMenuDropdown($item, !isOpen);
        });

        // Menu arrow touch (mobile) - using native event listener with passive: false
        document.querySelectorAll('.menu-arrow').forEach((arrow) => {
            arrow.addEventListener(
                'touchstart',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const $item = $(this).closest('li');
                    const isOpen = $item.hasClass('open');
                    toggleMenuDropdown($item, !isOpen);
                },
                { passive: false },
            );
        });

        // Menu link click (mobile only, with dropdown)
        $document.on('click', '.menu-link > a.link-title', function (e) {
            if ($mainMenuArea.hasClass('active') || isMobile()) {
                const $item = $(this).closest('li.menu-link');
                const $dropdown = $item.find('.menu-dropdown').eq(0);

                if ($dropdown.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();

                    const isOpen = $item.hasClass('open');
                    toggleMenuDropdown($item, !isOpen);
                }
            }
        });

        // Menu link touch (mobile only, with dropdown) - using native event listener with passive: false
        document.querySelectorAll('.menu-link > a.link-title').forEach((link) => {
            link.addEventListener(
                'touchstart',
                function (e) {
                    if ($mainMenuArea.hasClass('active') || isMobile()) {
                        const $item = $(this).closest('li.menu-link');
                        const $dropdown = $item.find('.menu-dropdown').eq(0);

                        if ($dropdown.length > 0) {
                            e.preventDefault();
                            e.stopPropagation();

                            const isOpen = $item.hasClass('open');
                            toggleMenuDropdown($item, !isOpen);
                        }
                    }
                },
                { passive: false },
            );
        });

        // Back menu button
        $document.on('click', '.back-menu', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $dropdown = $(this).closest('.menu-dropdown');
            setTimeout(() => $dropdown.removeClass('open'), ANIMATION_DELAY);
            $('.menu-link').removeClass('open');
            $menuContent.removeClass('open-level-1');
        });

        // Hotspot toggle
        const toggleHotspot = function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $hotspot = $(this).closest('.st-hotspot');
            const $content = $hotspot.find('.st-content-parent').eq(0).find('.tt-hotspot-content').eq(0);
            const isOpen = $hotspot.hasClass('open');

            if (isOpen) {
                $content.removeClass('open');
                setTimeout(() => $hotspot.removeClass('open'), MENU_ANIMATION_DELAY);
            } else {
                $hotspot.addClass('open');
                setTimeout(() => $content.addClass('open'), MENU_ANIMATION_DELAY);
            }
        };

        // Hotspot click handler
        $document.on('click', '.st-hotspot .st-btn', toggleHotspot);

        // Hotspot touch handler for iOS - using touchend for better compatibility
        $document.on('touchend', '.st-hotspot .st-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleHotspot.call(this, e);
        });

        // Desktop menu hover
        $('ul.main-menu li.menu-link').hover(
            function () {
                $(this).children('.menu-dropdown').stop().slideDown(MENU_ANIMATION_DELAY);
            },
            function () {
                $(this).children('.menu-dropdown').stop().slideUp(MENU_ANIMATION_DELAY);
            },
        );

        // Share icons toggle
        $document.on('click', '.share-icons .share-icon', function () {
            $('.social-box').fadeToggle('active');
        });
    });

    // Search modal handler
    $('#searchmodal').on('hidden.bs.modal', function () {
        const predictiveSearch = document.querySelector('predictive-search');
        if (predictiveSearch) {
            predictiveSearch.removeAttribute('open');
        }
    });
})(jQuery);
